module.exports = __webpack_public_path__ + "static/media/youtube-white.7cd49859.svg";